import parseRenderingContext from '@utils/parse-rendering-context';
import AjaxLoader from '../ajax-loader/ajax-loader';
import CheckoutLine from './checkout-line';
import CheckoutReviewSummary from './checkout-review-summary';
import template, { link as linkHtmlStr } from './templates/checkout-review';
import { context as defaultContext } from './checkout-defaults';
import store from '@stores/cart/cart-store';

export default class CheckoutReview {
    constructor($originalEl, context) {
        context = { ...defaultContext, ...context };

        const $parsed = $($.parseHTML(template));
        $originalEl.replaceWith($parsed);
        this.$el = $parsed;

        this.$billingAddressLabel = this.$el.find('[data-label="billingAddress"]');
        this.$editCartLabel = this.$el.find('[data-label="editCart"]');
        this.$itemsLabel = this.$el.find('[data-label="items"]');
        this.$paymentMethodLabel = this.$el.find('[data-label="paymentMethod"]');
        this.$shippingAddressLabel = this.$el.find('[data-label="shippingAddress"]');
        this.$shippingMethodLabel = this.$el.find('[data-label="shippingMethod"]');

        this.$billingAddress = this.$el.find('[data-region="billingAddress"]');
        this.$lines = this.$el.find('[data-region="lines"]');
        this.$paymentMethod = this.$el.find('[data-region="paymentMethod"]');
        this.$shippingAddress = this.$el.find('[data-region="shippingAddress"]');
        this.$shippingMethod = this.$el.find('[data-region="shippingMethod"]');

        this.$linesLoader = this.$el.find('[data-loader="lines"]');
        this.$loaders = this.$el.find('[data-loader="loader"]');
        this.$prescription = $('.cart-landing__rx[data-region="prescription"]');

        this.$billingAddressPlaceholder = this.$el.find('[data-placeholder="editBillingAddress"]');
        this.$editCartPlaceholder = this.$el.find('[data-placeholder="editCart"]');
        this.$paymentMethodPlaceholder = this.$el.find('[data-placeholder="editPaymentMethod"]');
        this.$shippingAddressPlaceholder = this.$el.find('[data-placeholder="editShippingAddress"]');
        this.$shippingMethodPlaceholder = this.$el.find('[data-placeholder="editShippingMethod"]');
        this.$summaryPlaceholder = this.$el.find('[data-placeholder="summary"]');

        this.linesLoader = null;
        this.loaders = [];

        this.summary = null;

        this.context = context;
    }

    init() {
        this.renderLabels();
        this.renderLinks();
        this.setupLoaders();
        this.setupSummary();
    }

    onCartLoaded() {
        this.loaders.forEach(loader => (loader.active = false));
        this.summary.reactive.loading = false;
        this.renderCheckoutInfo();
        this.renderCartLines();
    }

    renderLabels() {
        this.$billingAddressLabel.html(this.context.BillingAddress);
        this.$editCartLabel.html(this.context.EditShoppingCart);
        this.$itemsLabel.html(this.context.Items);
        this.$paymentMethodLabel.html(this.context.PaymentMethod);
        this.$shippingAddressLabel.html(this.context.ShippingAddress);
        this.$shippingMethodLabel.html(this.context.ShippingMethod);
    }

    renderLinks() {
        if(this.context.EditBillingAddressLink) {
            const link = linkHtmlStr({
                text: this.context.EditBillingAddressLink.Text,
                url: this.context.EditBillingAddressLink.Url
            });
            this.$billingAddressPlaceholder.replaceWith(link);
        }

        if(this.context.EditCartLink) {
            const link = linkHtmlStr({
                text: this.context.EditCartLink.Text,
                url: this.context.EditCartLink.Url
            });
            this.$editCartPlaceholder.replaceWith(link);
        }

        if(this.context.EditShippingAddressLink) {
            const link = linkHtmlStr({
                text: this.context.EditShippingAddressLink.Text,
                url: this.context.EditShippingAddressLink.Url
            });
            this.$shippingAddressPlaceholder.replaceWith(link);
        }

        if(this.context.EditPaymentMethodLink) {
            const link = linkHtmlStr({
                text: this.context.EditPaymentMethodLink.Text,
                url: this.context.EditPaymentMethodLink.Url
            });
            this.$paymentMethodPlaceholder.replaceWith(link);
        }

        if(this.context.EditShippingMethodLink) {
            const link = linkHtmlStr({
                text: this.context.EditShippingMethodLink.Text,
                url: this.context.EditShippingMethodLink.Url
            });
            this.$shippingMethodPlaceholder.replaceWith(link);
        }
    }

    renderCartLines() {
        this.$lines.empty();
        this.$lines.hide();
        let displayRxRequired = false;

        store.getters.lines.forEach(line => {
            const component = new CheckoutLine(null, this.context, line);
            this.$lines.append(component.$el);
            if (line.rxRequired) displayRxRequired = true;
        });

        displayRxRequired ? this.$prescription.show() : this.$prescription.hide();;
    
        this.$lines.slideDown();
    }

    renderCheckoutInfo() {
        const shippingAddress = store.getters.formattedShippingAddress;
        let billingAddress = store.getters.formattedBillingAddress;
        if(shippingAddress === billingAddress) {
            billingAddress = 'Same as Shipping';
        }

        this.$billingAddress.html(billingAddress || 'n/a');
        this.$paymentMethod.html(store.getters.cardPreview || 'n/a');
        this.$shippingAddress.html(shippingAddress || 'n/a');
        this.$shippingMethod.html(store.state.shippingMethod?.ShippingMethodName || 'n/a');
    }

    setupLoaders() {
        this.$loaders.each((index) => {
            const $el = this.$loaders.eq(index);
            this.loaders.push(new AjaxLoader($el, {
                aria: false,
                className: 'd-flex align-items-center h-100',
                size: 'xs',
                visible: true
            }));
        });

        this.linesLoader = new AjaxLoader(this.$linesLoader, {
            aria: false,
            size: 'sm',
            visible: true
        });
    }

    setupSummary() {
        this.summary = new CheckoutReviewSummary(this.$summaryPlaceholder, this.context);
        this.summary.init();
        this.summary.reactive.loading = true;
    }
}

$(async () => {
    const rootEls = document.querySelectorAll('.js-checkout-review');
    rootEls.forEach((el) => {
        const $el = $(el);
        const renderingContext = parseRenderingContext(el);

        const review = new CheckoutReview($el, renderingContext);
        review.init();
        
        const unwatchLoaded = store.watch('loaded', (...[,,loaded]) => {
            if(loaded) {
                review.onCartLoaded();
                unwatchLoaded();
            }
        });
    });

    if(rootEls.length) {
        store.actions.getCart();
        store.mutations.SET_IS_REVIEW(true);
    }
});
